module.exports = __webpack_public_path__ + "img/kia_logo.793e69ba.png";